import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useDispatch } from 'react-redux';
import { removeNotification } from '../../../actions/appNotifications';
import colors from '../../../scss/colors';
import { appNotificationsTypes, responsiveSizeTimesheet } from '../../../utils/constants';
import { horiontalPositions, verticalPositions } from '../../../utils/enums';
import { useWindowSize } from '../../../utils/hooks';

export default function AppNotification({ notification }) {
  const dispatch = useDispatch();
  const { width } = useWindowSize();

  const bgColors = {
    [appNotificationsTypes.SUCCESS]: colors.NAVY_BLUE
  };

  const closeNotification = () => dispatch(removeNotification());
  return !notification?.isAppStyled ? (
    <Snackbar
      open={!!notification}
      autoHideDuration={notification?.duration}
      anchorOrigin={{
        vertical: verticalPositions.BOTTOM,
        horizontal: horiontalPositions.RIGHT
      }}
      onClose={closeNotification}
      sx={{ zIndex: 10002 }}
    >
      <Alert
        severity={notification?.type}
        variant="filled"
        sx={{ minWidth: '328px', backgroundColor: colors.BLACK_TXT, color: colors.WHITE }}
      >
        {notification?.message}
      </Alert>
    </Snackbar>
  ) : (
    <Snackbar
      open={!!notification}
      anchorOrigin={{
        vertical: notification?.anchor?.vertical || verticalPositions.BOTTOM,
        horizontal: notification?.anchor?.horizontal || horiontalPositions.LEFT
      }}
      autoHideDuration={notification?.duration}
      message={notification?.message}
      onClose={closeNotification}
      sx={{
        '& .MuiSnackbarContent-root': { backgroundColor: bgColors[notification?.type] },
        '& .MuiSnackbar-root': { zIndex: 10002 },
        bottom: width > responsiveSizeTimesheet ? undefined : notification?.bottom
      }}
      action={notification?.action}
    />
  );
}
